export enum ConfirmVariants {
	Delete = 'delete',
	Warning = 'warning',
}
